import React, { useState, useEffect } from "react";  // Importing useState and useEffect
import { Container, Row, Col, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import MetaManager from "../MetaManager";
import OtherServicesCarousel from "../OtherServicesCarousel";
import CallToAction from "../Home/CallToAction/CallToAction";
import BannerForm from './BannerForm';
import Faq from "./Faq";
import './Services.css';
const PrintingCard = () => {

  const  servicesFaqData = [
    { 
        question: "What are greeting and holiday cards, and where are they used? ", 
        answer: "Greeting and holiday cards are printed cards designed to convey messages of celebration, gratitude, or well-wishes for various occasions. They are commonly used for personal milestones, festive seasons, corporate thank-yous, and event invitations. These cards help strengthen relationships by adding a personal and thoughtful touch to your communication. Greeting and holiday cards can be customised with unique designs, messages, or logos to align with personal preferences or branding. Whether sent to friends, family, or clients, these cards create a meaningful and memorable connection."
    },
    { 
        question: "What are the benefits of customized greeting cards printing?  ", 
        answer: "Customized greeting cards printing allows you to tailor your cards to reflect your personality, brand, or message. You can include unique designs, custom text, and even company logos to make the cards stand out. Customisation ensures that the cards resonate with the recipient, creating a lasting impression. High-quality materials and printing techniques enhance the card’s appearance, adding a professional and elegant touch. Personalized cards also demonstrate thoughtfulness and effort, making them ideal for personal or corporate use."
    },
    { 
        question: "Can Printingy handle bulk orders for greeting and holiday cards? ", 
        answer: "Yes, Printingy specialises in bulk custom greeting cards printing, providing cost-effective solutions for large-scale orders. Bulk printing is ideal for businesses, organisations, or individuals needing multiple cards for seasonal greetings, corporate branding, or event invitations. Advanced printing technology ensures consistent quality across all cards, regardless of order size. We also offer flexible customisation options to meet specific needs. With quick turnaround times, Printingy ensures that your bulk orders are ready on time without compromising on quality."
    },
    { 
        question: "What materials are used for holiday cards greetings card printing?  ", 
        answer: "Our holiday cards greetings card printing services use premium materials such as textured cardstock, glossy paper, or eco-friendly options. Textured cardstock adds a sophisticated touch, ideal for formal or festive greetings. Glossy paper enhances colours and details, making the cards vibrant and eye-catching. For eco-conscious clients, we offer recycled materials that maintain quality while supporting sustainability. These materials ensure that your holiday cards are durable, visually appealing, and suited for mailing or hand-delivery."
    },
    { 
        question: "What industries and individuals benefit from greeting cards printing services?", 
        answer: "Businesses, event organisers, and individuals all benefit from Greeting & Holiday Cards Printing services. Businesses use these cards to express appreciation to clients, partners, and employees during the holiday season. Event organisers rely on customised cards for invitations, thank-yous, or special announcements. Individuals use personalised greeting cards to celebrate birthdays, anniversaries, and other milestones. These cards serve as a meaningful way to build relationships and add a personal touch to communication. Whether for professional or personal use, greeting cards enhance connections with style and thoughtfulness."
    },
];

    
const [pageTitle, setPageTitle] = useState('Printing of Greeting & Holiday Cards');  // Dynamic title state

useEffect(() => {
  document.title = pageTitle; // Set the document title dynamically
}, [pageTitle]); // This will run whenever the pageTitle changes

  return (
    <div>
    <MetaManager 
  title=" Custom Greeting & Holiday Cards Printing Services"
  description="High-quality printing of greeting and holiday cards for events and personal use. Bulk custom greeting cards printing, holiday cards printing, and personalised solutions."
  keywords="Printing of Greeting & Holiday Cards,
Greeting & Holiday Cards Printing,
Bulk Custom Greeting Cards Printing,
Customized Greeting Cards Printing,
Holiday Cards Greetings Card Printing
"
/>


      <header className="services-header text-center py-5  serviceheader">
        <Container>
          <Row className="align-item-cen">
            <Col lg={6}>
              <h1>Professional Printing of Greeting & Holiday Cards  </h1>
              <h2 className="text-muted">Customised greeting cards for holidays, events, and celebrations   </h2>
            </Col>

            {/* Contact Form on the Right Side */}
            <Col lg={6}>
              <div className="contact-form p-4 bg-white shadow-sm rounded" style={{ maxWidth: "400px", margin: "auto" }}>
                <h3 className="text-center mb-4">Get in Touch</h3>
                <BannerForm />
              </div>
            </Col>
          </Row>
        </Container>
      </header>

      <section className="services-overview ">
        <Container>
          <p>Greeting and holiday cards are a timeless way to share warmth, gratitude, and celebration during special occasions. Printingy specialises in Printing of Greeting & Holiday Cards, delivering high-quality Greeting & Holiday Cards Printing for personal and professional needs.</p>
          <p>Our services include bulk custom greeting cards printing, ideal for businesses and individuals looking to connect with their audience or loved ones. For personalised designs, we offer customized greeting cards printing with vibrant visuals and premium finishes. Whether for corporate holiday cards or personal greetings, our holiday cards greetings card printing ensures that your message is delivered with elegance and style.</p>
          
          
        </Container>
      </section>

      <section className="why-choose py-5">
        <Container>
          <h2 className="text-center mb-4">Why Choose Printingy</h2>

          {/* Custom Flyer Printing Experts */}
          <div className="py-4 px-3 rounded mb-4">
            <Row>
              <Col lg={6}>
              <h2 className="small-hed">Reliable Custom Greeting & Holiday Card Printing Solutions </h2>
                <h3 className="large-hed">High-quality, vibrant, and personalised cards for every occasion </h3>

                <ul className="list-unstyled">
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Expert Printing of Greeting & Holiday Cards for all occasions. 
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Bulk Greeting & Holiday Cards Printing with cost-effective pricing.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Fully tailored customized greeting cards printing to reflect your style.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Professional holiday cards greetings card printing with premium materials.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Vibrant colours and sharp details for a lasting impression.

                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Durable cards designed to withstand handling and mailing.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Quick turnaround times for bulk and customised orders.
                  </li>
                  <li>
                    <FontAwesomeIcon icon={faCheck} className="text-success me-2" />
                    Trusted solutions for businesses, event organisers, and personal projects.
                  </li>
                </ul>
                <Button variant="primary" className="mt-3">
                  Contact Us
                </Button>
              </Col>

              {/* Contact Form on the Right Side */}
              <Col lg={6}>
                <img
                  src="/assets/img/greetingcards.jpg" // Path relative to the public folder
                  alt="Professional printing of greeting and holiday cards services"
                  className="img-fluid rounded"
                />
              </Col>
            </Row>
          </div>
          <CallToAction 
       title="Connect with us Today"
        description="Your trusted Partner for Bulk Printing Solutions..!"
      />
          {/* Professional Flyer Printing with Precision */}
          <div className="shadow-sm p-4 rounded">
            <h2 className="large-hed">Premium Greeting & Holiday Cards Delivered On Time  </h2>
            <h3 className="small-hed">Focus on your message while we handle your card printing needs  </h3>
            <p>At Printingy, we deliver exceptional Greeting & Holiday Cards Printing using advanced technology and high-quality materials. Whether for holiday celebrations, corporate thank-yous, or personal greetings, our bulk custom greeting cards printing services ensure professional results.
            </p>
            <p>We prioritise efficiency and quality, guaranteeing that your cards are delivered on schedule, whether for a small batch or a bulk order. Partner with Printingy for reliable and elegant greeting and holiday card solutions.
            </p>
          </div>
        </Container>
      </section>



      <div>
  {/* Existing Content */}
  <OtherServicesCarousel />
  {/* Other Content */}
</div>

<Faq faqData={servicesFaqData} />
   
    </div>
  );
};

export default PrintingCard;
